'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var error = {
  light: '#FFEBEE',
  main: '#D81B60',
  dark: '#AD1457',
  contrastText: '#FFFFFF' //White

};
var alert = {
  light: '#FFF8E1',
  main: '#FFE082',
  dark: '#FFB300',
  contrastText: '#212121' //HCP black

};
var success = {
  light: '#E8F5E9',
  main: '#00C853',
  dark: '#2E7D32',
  contrastText: '#212121' //HCP black

};
var info = {
  light: '#BBDEFB',
  main: '#0F77CC',
  dark: '#1565C0',
  contrastText: '#FFFFFF' //White

};
var common = {
  white: '#FFFFFF',
  black: '#212121'
};
var grey = {
  '50': '#FAFAFA',
  '100': '#F5F5F5',
  '200': '#EEEEEE',
  '300': '#E0E0E0',
  '400': '#BDBDBD',
  '500': '#9E9E9E',
  '600': '#757575',
  '700': '#616161',
  '800': '#424242',
  '900': '#212121',
  'A100': '#D5D5D5',
  'A200': '#AAAAAA',
  'A400': '#303030',
  'A700': '#616161' //Dim grey

};

exports.alert = alert;
exports.common = common;
exports.error = error;
exports.grey = grey;
exports.info = info;
exports.success = success;
